module.exports = __webpack_public_path__ + "img/middle-banner.a83cb025.png";